import React from "react";
import styles from "./slider.module.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./swiper.css";
import { Navigation } from "swiper/modules";
import { Col, Container, Row } from "react-bootstrap";
import { Heading, Paragraph } from "../TextComponents/TextComponents";
import { Link } from "react-router-dom";
import { LightBgButton } from "../Buttons/LightBgButton";

const SliderService = ({ handleShow }) => {
  return (
    <React.Fragment>
      <div className={styles.main_section} id="program">
        <Container>
          <LightBgButton label={'Services'} bg="#CCD7FF" color="var(--primary-color)" />
          <div className={styles.aboutChild}>
            <Row>
              <Col md={6} sm={12}>
                <div >
                  <Heading>Our Core Services that we <br /> serve you</Heading>
                </div>
              </Col>
              <Col md={6} sm={12}>
                <div className={styles.rightSection}>
                  <Paragraph>
                    Whether you’re just starting or scaling your venture, our structured programs ensure you receive expert guidance and resources to overcome challenges.
                  </Paragraph>
                </div>
              </Col>
            </Row>
          </div>
        </Container>

        <Container>
          <Swiper
            slidesPerView={2.5}
            spaceBetween={50}
            navigation={true}
            modules={[Navigation]}
            breakpoints={{
              320: { slidesPerView: 1 },
              480: { slidesPerView: 1 },
              768: { slidesPerView: 2.5 },

            }}
            className={`mySwiper ${styles.swiper_section}`}
          >
            <SwiperSlide>
              <div className={styles.card}>
                <img src="/images/Homepage/icon/App-Development.png"
                  alt="Web & Mobile App Development - Buildshell" />
                <h6>Web & Mobile App Development</h6>
                <p>Scalable, high-performance apps for iOS, Android & Web.</p>
                <Link onClick={handleShow} to="#">Contact Us</Link>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className={styles.card}>
                <img src="/images/Homepage/icon/Ui-Development.png"
                  alt="UI/UX Design & Prototyping - Buildshell" />
                <h6>UI/UX Design & Prototyping</h6>
                <p>Captivating designs that enhance user engagement.</p>
                <Link onClick={handleShow} to="#">Contact Us</Link>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className={styles.card}>
                <img src="/images/Homepage/icon/Cloud-Development.png" 
                alt="SaaS & Cloud-Based Solutions - Buildshell" />
                <h6>SaaS & Cloud-Based Solutions</h6>
                <p>Secure, flexible cloud-based applications.</p>
                <Link onClick={handleShow} to="#">Contact Us</Link>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className={styles.card}>
                <img src="/images/Homepage/icon/Custom-Software.png" 
                alt="Custom Software Development - Buildshell" />
                <h6>Custom Software Development</h6>
                <p>Tailored enterprise solutions for automation & growth.</p>
                <Link onClick={handleShow} to="#">Contact Us</Link>
              </div>
            </SwiperSlide>

          </Swiper>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SliderService;
